import React from "react";
import { MapPin, Search, Loader2, User, Phone } from "lucide-react";

const DeliveryRouteInput = ({
  title,
  placeholder,
  icon: Icon,
  name,

  formData,
  errors,

  activeAddressField,
  activeAddressFieldRef,
  suggestionsWrapperRef,

  setActiveAddressField,
  handleShowRecentAddresses,
  updateRouteField,

  getLatKeyName,
  getLngKeyName,

  currentLocationLoading,
  placesAutoCompletionLoading,
  getFavouriteAddressLoading,
  getLatLongByPlaceIdLoading,
  resolvingLocation,

  customerInfo,

  showSuggestions,
  placeSuggestions,

  normalizeFavouriteAddress,
  normalizeSuggestion,
  handleSelectSuggestion,
}) => {
  const latKey = getLatKeyName(name);
  const lngKey = getLngKeyName(name);

  return (
    <div
      ref={activeAddressField === name ? suggestionsWrapperRef : null}
      className="relative flex items-start gap-3"
    >
      <div
        className={`mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
          activeAddressField === name
            ? "bg-blue-600 text-white"
            : "bg-blue-50 text-blue-500"
        }`}
      >
        <Icon size={17} />
      </div>

      <div className="w-full">
        <div className="mb-0.5 flex items-center justify-between gap-2">
          <p className="text-[12px] font-semibold text-slate-500">{title}</p>

          {formData?.[latKey] && formData?.[lngKey] && (
            <span className="rounded-full bg-green-50 px-2 py-0.5 text-[10px] font-bold text-green-700">
              Location set
            </span>
          )}
        </div>

        <div className="relative">
          <Search
            size={14}
            className="absolute left-0 top-1/2 -translate-y-1/2 text-slate-400"
          />

          <input
            type="text"
            value={formData?.[name] || ""}
            onFocus={() => {
              setActiveAddressField(name);
              activeAddressFieldRef.current = name;
              handleShowRecentAddresses(name);
            }}
            onChange={(e) => updateRouteField(name, e.target.value)}
            placeholder={
              name === "pickupAddress" && currentLocationLoading
                ? "Fetching current location..."
                : placeholder
            }
            className="w-full bg-transparent py-1.5 pl-5 text-[14px] font-medium text-slate-700 outline-none placeholder:font-normal placeholder:text-slate-400"
          />

          {(placesAutoCompletionLoading ||
            getFavouriteAddressLoading ||
            getLatLongByPlaceIdLoading ||
            resolvingLocation ||
            (name === "pickupAddress" && currentLocationLoading)) &&
            activeAddressField === name && (
              <Loader2
                size={14}
                className="absolute right-1 top-1/2 -translate-y-1/2 animate-spin text-blue-600"
              />
            )}
        </div>

        <div className="min-h-[10px]">
          {errors?.[name] && (
            <p className="mt-1 text-[11px] font-medium text-red-500">
              {errors[name]}
            </p>
          )}
        </div>

        {name === "pickupAddress" && (
          <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-500">
            <span className="inline-flex items-center gap-1">
              <User size={12} className="text-blue-500" />
              <span className="font-semibold text-slate-600">
                {formData?.senderName || customerInfo.name || "Sender"}
              </span>
            </span>

            <span className="inline-flex items-center gap-1">
              <Phone size={12} className="text-blue-500" />
              <span className="font-semibold text-slate-600">
                {formData?.senderMobile || customerInfo.mobile || "Mobile"}
              </span>
            </span>
          </div>
        )}

        {showSuggestions &&
          activeAddressField === name &&
          placeSuggestions.length > 0 && (
            <div className="absolute left-12 right-0 top-[54px] z-50 max-h-[190px] overflow-y-auto rounded-2xl border border-slate-100 bg-white p-2 shadow-2xl [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
              {placeSuggestions.map((item, index) => {
                const suggestion = item?.isFavourite
                  ? normalizeFavouriteAddress(item)
                  : normalizeSuggestion(item);

                return (
                  <button
                    key={
                      item?.place_id ||
                      item?.placeId ||
                      item?.id ||
                      `${suggestion.displayAddress}-${index}`
                    }
                    type="button"
                    onClick={() => handleSelectSuggestion(item)}
                    className="flex w-full gap-2 rounded-xl px-3 py-2 text-left transition hover:bg-blue-50"
                  >
                    <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-blue-100 text-blue-700">
                      <MapPin size={15} />
                    </span>

                    <span className="min-w-0">
                      <span className="flex items-center gap-2">
                        <span className="block truncate text-[13px] font-bold text-slate-800">
                          {suggestion.displayAddress || "Unnamed location"}
                        </span>

                        {suggestion.isFavourite && (
                          <span className="shrink-0 rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-bold text-blue-700">
                            Saved
                          </span>
                        )}
                      </span>

                      {suggestion.secondaryText && (
                        <span className="mt-0.5 block truncate text-[11px] text-slate-500">
                          {suggestion.secondaryText}
                        </span>
                      )}
                    </span>
                  </button>
                );
              })}
            </div>
          )}
      </div>
    </div>
  );
};

export default DeliveryRouteInput;